
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/list/[path]",
      function () {
        return require("private-next-pages/list/[path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/list/[path]"])
      });
    }
  